(function () {
  'use strict';

  const wrapper = document.getElementById('fds-delivery-selector');
  if (!wrapper) return;

  const CFG = window.FDS_CONFIG || {};
  const CUTOFF_HOUR = CFG.cutoffHour || 18;
  const BLACKOUT = CFG.blackoutDates || [];
  const MAX_AHEAD = CFG.maxDaysAhead || 60;
  const SAVED_DATE = CFG.savedDate || '';
  const SAVED_TIME = CFG.savedTime || '';

  const dateDisplay = document.getElementById('fds-date-display');
  const calendar = document.getElementById('fds-calendar');
  const calDays = document.getElementById('fds-cal-days');
  const prevBtn = document.getElementById('fds-prev-month');
  const nextBtn = document.getElementById('fds-next-month');
  const monthSelect = document.getElementById('fds-month-select');
  const yearSelect = document.getElementById('fds-year-select');
  const timeSelect = document.getElementById('fds-time-select');
  const hiddenDate = document.getElementById('fds-hidden-date');
  const hiddenTime = document.getElementById('fds-hidden-time');
  const dateError = document.getElementById('fds-date-error');
  const timeError = document.getElementById('fds-time-error');

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let viewYear = today.getFullYear();
  let viewMonth = today.getMonth();
  let selectedDate = null;

  const backdrop = document.createElement('div');
  backdrop.className = 'fds-backdrop';
  document.body.appendChild(backdrop);

  const MONTHS = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];

  function dateToISO(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2,'0');
    const day = String(d.getDate()).padStart(2,'0');
    return `${y}-${m}-${day}`;
  }

  function isDisabled(d) {
    const dCopy = new Date(d);
    dCopy.setHours(0,0,0,0);
    if (dCopy < today) return true;
    if (dCopy.getTime() === today.getTime()) {
      const nowHour = new Date().getHours();
      if (nowHour >= CUTOFF_HOUR) return true;
    }
    if (BLACKOUT.includes(dateToISO(dCopy))) return true;
    const maxDate = new Date(today);
    maxDate.setDate(today.getDate() + MAX_AHEAD);
    if (dCopy > maxDate) return true;
    return false;
  }

  function buildMonthYearSelects() {
    monthSelect.innerHTML = '';
    MONTHS.forEach((m, i) => {
      const opt = document.createElement('option');
      opt.value = i;
      opt.textContent = m;
      if (i === viewMonth) opt.selected = true;
      monthSelect.appendChild(opt);
    });

    yearSelect.innerHTML = '';
    const startYear = today.getFullYear();
    const endYear = startYear + 2;
    for (let y = startYear; y <= endYear; y++) {
      const opt = document.createElement('option');
      opt.value = y;
      opt.textContent = y;
      if (y === viewYear) opt.selected = true;
      yearSelect.appendChild(opt);
    }
  }

  function renderCalendar() {
    buildMonthYearSelects();
    calDays.innerHTML = '';

    const firstDay = new Date(viewYear, viewMonth, 1).getDay();
    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
    const daysInPrevMonth = new Date(viewYear, viewMonth, 0).getDate();

    for (let i = firstDay - 1; i >= 0; i--) {
      addDayCell(new Date(viewYear, viewMonth - 1, daysInPrevMonth - i), true);
    }

    for (let d = 1; d <= daysInMonth; d++) {
      addDayCell(new Date(viewYear, viewMonth, d), false);
    }

    const total = firstDay + daysInMonth;
    const remainder = total % 7 === 0 ? 0 : 7 - (total % 7);
    for (let d = 1; d <= remainder; d++) {
      addDayCell(new Date(viewYear, viewMonth + 1, d), true);
    }

    const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const viewStart = new Date(viewYear, viewMonth, 1);
    prevBtn.disabled = viewStart <= thisMonthStart;
  }

  function addDayCell(date, isOtherMonth) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = date.getDate();

    const disabled = isDisabled(date);
    const isToday = date.toDateString() === today.toDateString();
    const isSelected = selectedDate && date.toDateString() === selectedDate.toDateString();

    btn.className = [
      'fds-day',
      isOtherMonth ? 'fds-day--other-month' : '',
      disabled ? 'fds-day--disabled' : '',
      isToday ? 'fds-day--today' : '',
      isSelected ? 'fds-day--selected' : '',
    ].filter(Boolean).join(' ');

    if (!disabled) {
      btn.addEventListener('click', () => {
        selectedDate = date;
        hiddenDate.value = dateToISO(date);
        dateDisplay.value = dateToISO(date);
        dateDisplay.classList.add('has-value');
        clearError(dateDisplay, dateError);
        closeCalendar();
        renderCalendar();
        syncCartAttribute('Delivery Date', dateToISO(date));
      });
    }

    calDays.appendChild(btn);
  }

  function openCalendar() {
    calendar.hidden = false;
    dateDisplay.setAttribute('aria-expanded', 'true');
    backdrop.classList.add('active');
    renderCalendar();
  }

  function closeCalendar() {
    calendar.hidden = true;
    dateDisplay.setAttribute('aria-expanded', 'false');
    backdrop.classList.remove('active');
  }

  function toggleCalendar() {
    if (calendar.hidden) { openCalendar(); } else { closeCalendar(); }
  }

  function syncCartAttribute(key, value) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [key]: value } })
    }).catch(() => {});
  }

  function validate() {
    let valid = true;
    if (!hiddenDate.value) { showError(dateDisplay, dateError); valid = false; }
    if (!hiddenTime.value) { showError(timeSelect, timeError); valid = false; }
    return valid;
  }

  function showError(input, errorEl) {
    input.classList.add('fds-invalid');
    errorEl.hidden = false;
  }

  function clearError(input, errorEl) {
    input.classList.remove('fds-invalid');
    errorEl.hidden = true;
  }

  function interceptCheckout() {
    document.addEventListener('click', function(e) {
      const target = e.target.closest(
        '[name="checkout"], .btn.checkout, #cartCheckout, .cart__checkout-button, a[href="/checkout"]'
      );
      if (!target) return;
      if (!validate()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }

  prevBtn.addEventListener('click', () => {
    viewMonth--;
    if (viewMonth < 0) { viewMonth = 11; viewYear--; }
    renderCalendar();
  });

  nextBtn.addEventListener('click', () => {
    viewMonth++;
    if (viewMonth > 11) { viewMonth = 0; viewYear++; }
    renderCalendar();
  });

  monthSelect.addEventListener('change', () => {
    viewMonth = parseInt(monthSelect.value, 10);
    renderCalendar();
  });

  yearSelect.addEventListener('change', () => {
    viewYear = parseInt(yearSelect.value, 10);
    renderCalendar();
  });

  dateDisplay.addEventListener('click', toggleCalendar);

  document.addEventListener('click', (e) => {
    if (!calendar.hidden && !wrapper.contains(e.target) && !backdrop.contains(e.target)) {
      closeCalendar();
    }
  });

  backdrop.addEventListener('click', closeCalendar);

  timeSelect.addEventListener('change', () => {
    const val = timeSelect.value;
    hiddenTime.value = val;
    timeSelect.classList.toggle('has-value', !!val);
    clearError(timeSelect, timeError);
    syncCartAttribute('Delivery Time', val);
  });

  function restoreSavedValues() {
    if (SAVED_DATE) {
      const parts = SAVED_DATE.split('-');
      if (parts.length === 3) {
        const d = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        if (!isNaN(d) && !isDisabled(d)) {
          selectedDate = d;
          hiddenDate.value = SAVED_DATE;
          dateDisplay.value = SAVED_DATE;
          dateDisplay.classList.add('has-value');
          viewYear = d.getFullYear();
          viewMonth = d.getMonth();
        }
      }
    }
    if (SAVED_TIME) {
      const opt = [...timeSelect.options].find(o => o.value === SAVED_TIME);
      if (opt) {
        timeSelect.value = SAVED_TIME;
        hiddenTime.value = SAVED_TIME;
        timeSelect.classList.add('has-value');
      }
    }
  }

  restoreSavedValues();
  interceptCheckout();

})();